import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Grid, Card, CardContent, Typography, Stack, Button, Avatar, Box, CircularProgress } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import PageLayout from "examples/LayoutContainers/PageLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import image042 from '../../assets/custom-icon/image042.jpg';
import { url ,fileUploadUrl } from "../../constant";

import Link from '@mui/material/Link';
import LinkIcon from '@mui/icons-material/Link';
import AttachFileIcon from '@mui/icons-material/AttachFile';

const RequestDetails = () => {
  const navigate = useNavigate();
  const [showFullDescription, setShowFullDescription] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const requestId = queryParams.get('requestId');
  const [specificRequest, setSpecificRequest] = useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [requestTypes, setRequestTypes] = React.useState([]);


  useEffect(() => {
    if (requestId) {
      
      // fetch(`${url}auth/requests-details-specific/${requestId}`)
      //   .then((response) => response.json())
      //   .then((result) => {
      //     // if (result.message === "Request retrieved successfully.") {
      //     if (result.data.length) {
      //       setSpecificRequest(result.data[0]);
      //     } else {
      //       window.location.href = '/authentication/log-out';
      //       console.error("Failed to retrieve request details.");
      //     }
      //   })
      //   .catch((error) => {
      //     console.error("Error fetching request details:", error);
      //   });

      fetchRequestTypes();

    }
  }, [requestId]);


   const fetchRequestTypes = async () => {
      try {
        setIsLoading(true);
        const response = await fetch(`${url}auth/get-request-types`);
        const data = await response.json();
        setRequestTypes(data.data || []);
  
        fetch(`${url}auth/requests-details-specific/${requestId}`)
          .then((response) => response.json())
          .then((result) => {
            // if (result.message === "Request retrieved successfully.") {
            if (result.data.length) {
              setSpecificRequest(result.data[0]);
            } else {
              window.location.href = '/authentication/log-out';
              console.error("Failed to retrieve request details.");
            }
          })
          .catch((error) => {
            console.error("Error fetching request details:", error);
          });
  
  
      } catch (error) {
        console.error("Error fetching request types:", error);
      } finally {
        setIsLoading(false);
      }
  
    };


  const handleBackClick = () => {
    navigate('/dashboard/requests');
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleToggleDescription = () => {
    setShowFullDescription(!showFullDescription);
  };

  const truncatedDescription = (text, limit) => {
    if (text.length > limit) {
      return `${text.substring(0, limit)}...`;
    }
    return text;
  };

  if (!specificRequest) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          zIndex: 9999,
        }}
      >
        <CircularProgress size={60} color="secondary" />
      </Box>
    );
  }

  const sendEmail = (id) => {
    var akLoginUser = JSON.parse(localStorage.getItem('user'));
    //alert(akLoginUser.user.email);
    var formData = new FormData();
    formData.append('cc_email', akLoginUser.user.email)
    fetch(`${url}auth/send-request-email/${id}`, {
      method: 'POST',
      body: formData
    }).then(res => {
      return res.json();
    }).then(json => {
      alert(json.message);
    })
  }

  return (
    <PageLayout>

      <Grid container spacing={2} justifyContent="center" sx={{ padding: '2rem' }}>
        <Grid item xs={12} sm={8} md={6} lg={8}>
          <Card sx={{ padding: '2rem', boxShadow: 3 }}>
            <CardContent>
              <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={2}
                alignItems="center"
                sx={{ width: '100%' }}
              >
                <Avatar
                  sx={{
                    bgcolor: '#4A60AE',
                    width: { xs: 45, sm: 56 },
                    height: { xs: 45, sm: 56 },
                  }}
                  src={image042}
                >
                  {!image042 && specificRequest.Title[0].toUpperCase()}
                </Avatar>
                <Box sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 'bold',
                      fontSize: { xs: '1.2rem', sm: '1.5rem' },
                    }}
                  >
                    {specificRequest.Title}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    sx={{
                      fontSize: { xs: '0.9rem', sm: '1rem' },
                    }}
                  >
                    pubblicata il: {formatDate(specificRequest.PublishDate)}
                  </Typography>
                </Box>
              </Stack>
              <Box mt={2}>
                <Typography variant="body1" paragraph>
                  <strong>Descrizione:</strong>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    sx={{
                      // maxHeight: showFullDescription ? 'none' : '150px',
                      // overflow: 'hidden',
                      // textOverflow: 'ellipsis',
                      // lineClamp: 3,
                      // display: '-webkit-box',
                      // WebkitLineClamp: showFullDescription ? 'none' : 3,
                      // WebkitBoxOrient: 'vertical',
                      // transition: 'max-height 0.3s ease',
                      whiteSpace: 'pre-line',
                    }}
                  >
                    {/* {showFullDescription ? specificRequest.Description : truncatedDescription(specificRequest.Description, 150)} */}
                    {specificRequest.Description}
                  </Typography>
                  {/* <Button
                    onClick={handleToggleDescription}
                    sx={{ textTransform: 'none', marginTop: 1 }}
                    size="small"
                    color="primary"
                  >
                    {showFullDescription ? 'Show Less' : 'Show More'}
                  </Button> */}
                </Typography>
                <Typography variant="body1" paragraph>
                  <strong>Categoria:</strong> {specificRequest.CategoryName}
                </Typography>
                <Typography variant="body1" paragraph>
                  <strong>Tipologia:</strong> {specificRequest.TypeName}
                </Typography>
                {/* <Typography variant="body1" paragraph>
                  <strong>Azienda:</strong> {specificRequest.CompanyName}
                </Typography> */}

                {/* <Typography variant="body1" paragraph>
                  <strong>Attachment: </strong>
                  {specificRequest.attachment ? (

                    <Link
                      onClick={() => window.open(`${fileUploadUrl}/${specificRequest.attachment ?? null}`, '_blank')}
                    >
                      {specificRequest.attachment}
                    </Link>

                  ) : (
                    ' No attachment available.'
                  )}
                </Typography> */}

                {/* specificRequest.ItDev */}

                {requestTypes.find( x => x.IdRequestType == specificRequest.IdTypeRequest).ItDev ? (

                  <>

                    <Typography variant="body1" paragraph>
                      <strong>Luogo:</strong> {specificRequest.Location}
                    </Typography>
                    <Typography variant="body1" paragraph>
                      <strong>Rate giornaliero:</strong> {specificRequest.DailyRate}€
                    </Typography>
                    <Typography variant="body1" paragraph>
                      <strong>Esperienza:</strong> {specificRequest.ExperienceYears} years
                    </Typography>
                    <Typography variant="body1" paragraph>
                      <strong>Full Remote:</strong> {specificRequest.FullRemote ? 'Si' : 'No'}
                    </Typography>
                    <Typography variant="body1" paragraph>
                      <strong>Lunga durata:</strong> {specificRequest.LongTerm ? 'Si' : 'No'}
                    </Typography>
                    <Typography variant="body1" paragraph>
                      <strong>Data inizio prevista:</strong> { specificRequest.DateStartAvailable == null ? '' : formatDate(specificRequest.DateStartAvailable)}
                    </Typography>
                    <Typography variant="body1" paragraph>
                      <strong>Data fine prevista:</strong> {specificRequest.DateEndAvailable == null ? '' : formatDate(specificRequest.DateEndAvailable)}
                    </Typography>

                  </>

                ) : ''}

                
                {specificRequest.attachment ? 
                  (
                    <Typography sx={{display: 'flex', flexDirection: 'row', alignItems: 'center'}} variant="body1" paragraph>
                      {/* <strong>Attachment: </strong> */}
                      <strong>Allegato: </strong>
                      {specificRequest.attachment ? (

                        <Link
                          onClick={() => window.open(`${fileUploadUrl}/${specificRequest.attachment ?? null}`, '_blank')}
                          sx={{cursor: 'pointer', marginLeft: '3px'}}
                        >
                          {/* {specificRequest.attachment.split('/')[1]} */}
                          {specificRequest.attachment_name}
                          {/* <AttachFileIcon fontSize={"20"} sx={{color: '#006bd6', display: 'flex', justifyContent: 'center', alignItems: 'center'}} /> */}
                        </Link>

                      ) : (
                        ' No attachment available.'
                      )}
                    </Typography>
                  ) : null}


                {/* {
                  specificRequest.LinkUrl ? (<Typography sx={{display: 'flex', flexDirection: 'row', alignItems: 'center'}} variant="body1" paragraph>
                    <strong>Attachment: </strong>
                    <strong>Collegamento: </strong>
                    {specificRequest.LinkUrl ? (

                      <Link
                        onClick={() => window.open(`${specificRequest.LinkUrl ?? null}`, '_blank')}
                        sx={{cursor: 'pointer', marginLeft: '3px'}}
                      >
                        {specificRequest.LinkDescription}
                        <LinkIcon fontSize={"20"} sx={{color: '#006bd6', display: 'flex', justifyContent: 'center', alignItems: 'center'}} />
                      </Link>

                    ) : (
                      ' No link available.'
                    )}
                  </Typography>) : null
                } */}

                {/* <strong>Descrizione Collegamento: </strong> */}
                
                {
                  specificRequest.LinkUrl ? (
                    <Typography sx={{ whiteSpace: 'pre-line', }} variant="body1" paragraph >
                      <strong>Descrizione Collegamento: </strong>
                      {specificRequest.LinkUrl ? (

                        <Link
                          onClick={() => window.open(`${specificRequest.LinkUrl ?? null}`, '_blank')}
                          sx={{ cursor: 'pointer', marginLeft: '3px' }}
                          color="textSecondary"
                        >
                          {specificRequest.LinkDescription}

                        </Link>

                      ) : (
                        ' No link available.'
                      )}
                    </Typography>) : null
                }

                {/* <Typography variant="body1" paragraph>
                  <strong>Creation Date:</strong> {formatDate(specificRequest.CreationDate)}
                </Typography> */}
                {/* <Typography variant="body1" paragraph>
                  <strong>Creation User:</strong> {specificRequest.CreationUser}
                </Typography> */}
                {/* <Typography variant="body1" paragraph>
                  <strong>Update Date:</strong> {formatDate(specificRequest.UpdateDate)}
                </Typography> */}
                {/* <Typography variant="body1" paragraph>
                  <strong>Update User:</strong> {specificRequest.UpdateUser}
                </Typography> */}
              </Box>
              <Stack direction="row" spacing={2} justifyContent="space-between" mt={2}>

                 <Button
                  variant="outlined"
                  sx={{
                    marginTop: '1rem',
                    borderRadius: '8px',
                    // backgroundColor: '#4A60AE',
                     // backgroundColor: 'hsl(210 100% 20%)',
                     backgroundColor: '#183759',
                    color: 'white',
                    ':hover': { backgroundColor: '#2C3E50' },
                  }}
                  onClick={()=>{
                    window.location.href = `/authentication/sign-in?requestId=${requestId}`;
                  }}
                >
                  LOG IN
                </Button>
{/*
                <Button
                  variant="outlined"
                  color="success"
                  sx={{
                    marginTop: '1rem',
                    borderRadius: '8px',
                    backgroundColor: '#66bb6a',
                    color: 'white',
                    ':hover': { backgroundColor: '#388e3c' },
                  }}
                  onClick={()=>{sendEmail(specificRequest.IdRequest)}}
                >
                  Richiedi info
                </Button> */}


              </Stack>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

    </PageLayout>
  );
};

export default RequestDetails;
